import { render } from "./AppFooter.vue?vue&type=template&id=fcb4b7b0"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=fcb4b7b0&lang=css"

import exportComponent from "/Users/ts/Desktop/works/vue3_portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__